import {
  sendDerivate,
  sendAggregated,
  cancelDerivation,
} from "../../helpers/fetching";

export default {
  state: {
    loading: false,
    error: null,
    response: {},
    dataDerivaion: {},
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setDerivateLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setDerivateResponse(state, data) {
      state.response = data;
    },
    setDataDerivation(state, data) {
      state.dataDerivaion = data;
    },
    resetDataDerivation(state, data) {
      state.dataDerivaion = data;
    },
  },
  actions: {
    toDerivate({ commit }, value) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setDerivateLoading", true);
        sendDerivate(value)
          .then((response) => {
            commit("setDerivateResponse", response);
            commit("setDerivateLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setDerivateLoading", false);
            resolve();
          });
      });
    },
    toAggregated({ commit }, value) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setDerivateLoading", true);
        sendAggregated(value)
          .then((response) => {
            commit("setDerivateResponse", response);
            commit("setDerivateLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setDerivateLoading", false);
            resolve();
          });
      });
    },
    setDataForDerivation({ commit }, data) {
      commit("setDataDerivation", data);
    },
    handleResetDataDerivation({ commit }) {
      commit("resetDataDerivation", {});
    },
    toCancelDerivate({ commit }, value) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setDerivateLoading", true);
        cancelDerivation(value)
          .then((response) => {
            commit("setDerivateResponse", response);
            commit("setDerivateLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setDerivateLoading", false);
            resolve();
          });
      });
    },
  },
};
